export default __webpack_public_path__ + "static/continuous-compliance3-b5f592cdb544a19c4dbe1b44e6c9f301.jpg";